/**
 * DetailInfo component.
 */
import Classification from '@components/elements/detail/detailClassification';
import Container from '@components/atoms/container/detailInfoContainer';
import Facts from '@components/elements/detail/detailFacts';
import Date from '@components/elements/detail/detailDate';

/**
 * Event metadata: facts line (channel | year | …), date, score / age code.
 */
export default function DetailInfo() {
  return (
    <Container>
      <Facts />
      <Date />
      <Classification />
    </Container>
  );
}
